/**
 * @flow
 * @relayHash 3e65eaf54e1c971c0decde772d9121d2
 */

/* eslint-disable */

"use strict";

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ReportSubscriptionVariables = {||};
export type ReportSubscriptionResponse = {|
  +reportSubscription: ?{|
    +action: ?string,
    +reportId: ?string,
    +report: ?{|
      +id: string,
      +pk: ?number,
      +createdAt: any,
      +afterWork: boolean,
      +project: {|
        +pk: ?number,
        +name: string,
        +color: ?string,
      |},
      +milestone: ?{|
        +pk: ?number
      |},
      +reportType: {|
        +pk: ?number,
        +labelDisplay: ?string,
        +color: string,
      |},
      +numberOfMinutes: number,
      +note: string,
      +taskId: ?string,
      +projectEmployee: ?{|
        +pk: ?number,
        +id: string,
        +user: ?{|
          +id: string
        |},
      |},
    |},
    +projectEmployeesTimeSpent: ?{|
      +edges: $ReadOnlyArray<?{|
        +node: ?{|
          +id: string,
          +pk: ?number,
          +project: {|
            +name: string,
            +id: string,
            +pk: ?number,
            +color: ?string,
          |},
          +monthlyTimeSpent: ?number,
        |}
      |}>
    |},
  |}
|};
export type ReportSubscription = {|
  variables: ReportSubscriptionVariables,
  response: ReportSubscriptionResponse,
|};
*/

/*
subscription ReportSubscription {
  reportSubscription {
    action
    reportId
    report {
      id
      pk
      createdAt
      afterWork
      project {
        pk
        name
        color
        id
      }
      milestone {
        pk
        id
      }
      reportType {
        pk
        labelDisplay
        color
        id
      }
      numberOfMinutes
      note
      taskId
      projectEmployee {
        pk
        id
        user {
          id
        }
      }
    }
    projectEmployeesTimeSpent {
      edges {
        node {
          id
          pk
          project {
            name
            id
            pk
            color
          }
          monthlyTimeSpent
        }
      }
    }
  }
}
*/

const node /*: ConcreteRequest*/ = (function () {
  var v0 = {
      kind: "ScalarField",
      alias: null,
      name: "action",
      args: null,
      storageKey: null,
    },
    v1 = {
      kind: "ScalarField",
      alias: null,
      name: "reportId",
      args: null,
      storageKey: null,
    },
    v2 = {
      kind: "ScalarField",
      alias: null,
      name: "pk",
      args: null,
      storageKey: null,
    },
    v3 = {
      kind: "ScalarField",
      alias: null,
      name: "id",
      args: null,
      storageKey: null,
    },
    v4 = {
      kind: "ScalarField",
      alias: null,
      name: "createdAt",
      args: null,
      storageKey: null,
    },
    v5 = {
      kind: "ScalarField",
      alias: null,
      name: "afterWork",
      args: null,
      storageKey: null,
    },
    v6 = {
      kind: "ScalarField",
      alias: null,
      name: "name",
      args: null,
      storageKey: null,
    },
    v7 = {
      kind: "ScalarField",
      alias: null,
      name: "color",
      args: null,
      storageKey: null,
    },
    v8 = {
      kind: "ScalarField",
      alias: null,
      name: "labelDisplay",
      args: null,
      storageKey: null,
    },
    v9 = {
      kind: "ScalarField",
      alias: null,
      name: "numberOfMinutes",
      args: null,
      storageKey: null,
    },
    v10 = {
      kind: "ScalarField",
      alias: null,
      name: "note",
      args: null,
      storageKey: null,
    },
    v11 = {
      kind: "ScalarField",
      alias: null,
      name: "taskId",
      args: null,
      storageKey: null,
    },
    v12 = {
      kind: "LinkedField",
      alias: null,
      name: "projectEmployee",
      storageKey: null,
      args: null,
      concreteType: "ProjectEmployeeType",
      plural: false,
      selections: [
        v2,
        v3,
        {
          kind: "LinkedField",
          alias: null,
          name: "user",
          storageKey: null,
          args: null,
          concreteType: "UserType",
          plural: false,
          selections: [v3],
        },
      ],
    },
    v13 = {
      kind: "LinkedField",
      alias: null,
      name: "projectEmployeesTimeSpent",
      storageKey: null,
      args: null,
      concreteType: "ProjectEmployeeConnection",
      plural: false,
      selections: [
        {
          kind: "LinkedField",
          alias: null,
          name: "edges",
          storageKey: null,
          args: null,
          concreteType: "ProjectEmployeeEdge",
          plural: true,
          selections: [
            {
              kind: "LinkedField",
              alias: null,
              name: "node",
              storageKey: null,
              args: null,
              concreteType: "ProjectEmployeeType",
              plural: false,
              selections: [
                v3,
                v2,
                {
                  kind: "LinkedField",
                  alias: null,
                  name: "project",
                  storageKey: null,
                  args: null,
                  concreteType: "ProjectType",
                  plural: false,
                  selections: [v6, v3, v2, v7],
                },
                {
                  kind: "ScalarField",
                  alias: null,
                  name: "monthlyTimeSpent",
                  args: null,
                  storageKey: null,
                },
              ],
            },
          ],
        },
      ],
    };
  return {
    kind: "Request",
    operationKind: "subscription",
    name: "ReportSubscription",
    id: null,
    text:
      "subscription ReportSubscription {\n  reportSubscription {\n    action\n    reportId\n    report {\n      id\n      pk\n      createdAt\n      afterWork\n      project {\n        pk\n        name\n        color\n        id\n      }\n      milestone {\n        pk\n        id\n      }\n      reportType {\n        pk\n        labelDisplay\n        color\n        id\n      }\n      numberOfMinutes\n      note\n      taskId\n      projectEmployee {\n        pk\n        id\n        user {\n          id\n        }\n      }\n    }\n    projectEmployeesTimeSpent {\n      edges {\n        node {\n          id\n          pk\n          project {\n            name\n            id\n            pk\n            color\n          }\n          monthlyTimeSpent\n        }\n      }\n    }\n  }\n}\n",
    metadata: {},
    fragment: {
      kind: "Fragment",
      name: "ReportSubscription",
      type: "Subscription",
      metadata: null,
      argumentDefinitions: [],
      selections: [
        {
          kind: "LinkedField",
          alias: null,
          name: "reportSubscription",
          storageKey: null,
          args: null,
          concreteType: "ReportSubscription",
          plural: false,
          selections: [
            v0,
            v1,
            {
              kind: "LinkedField",
              alias: null,
              name: "report",
              storageKey: null,
              args: null,
              concreteType: "ReportType",
              plural: false,
              selections: [
                {
                  kind: "LinkedField",
                  alias: null,
                  name: "milestone",
                  storageKey: null,
                  args: null,
                  concreteType: "MilestoneType",
                  plural: false,
                  selections: [v2],
                },
                v3,
                v4,
                v5,
                {
                  kind: "LinkedField",
                  alias: null,
                  name: "project",
                  storageKey: null,
                  args: null,
                  concreteType: "ProjectType",
                  plural: false,
                  selections: [v2, v6, v7],
                },
                v2,
                {
                  kind: "LinkedField",
                  alias: null,
                  name: "reportType",
                  storageKey: null,
                  args: null,
                  concreteType: "RoleType",
                  plural: false,
                  selections: [v2, v8, v7],
                },
                v9,
                v10,
                v11,
                v12,
              ],
            },
            v13,
          ],
        },
      ],
    },
    operation: {
      kind: "Operation",
      name: "ReportSubscription",
      argumentDefinitions: [],
      selections: [
        {
          kind: "LinkedField",
          alias: null,
          name: "reportSubscription",
          storageKey: null,
          args: null,
          concreteType: "ReportSubscription",
          plural: false,
          selections: [
            v0,
            v1,
            {
              kind: "LinkedField",
              alias: null,
              name: "report",
              storageKey: null,
              args: null,
              concreteType: "ReportType",
              plural: false,
              selections: [
                {
                  kind: "LinkedField",
                  alias: null,
                  name: "milestone",
                  storageKey: null,
                  args: null,
                  concreteType: "MilestoneType",
                  plural: false,
                  selections: [v2, v3],
                },
                v3,
                v4,
                v5,
                {
                  kind: "LinkedField",
                  alias: null,
                  name: "project",
                  storageKey: null,
                  args: null,
                  concreteType: "ProjectType",
                  plural: false,
                  selections: [v2, v6, v7, v3],
                },
                v2,
                {
                  kind: "LinkedField",
                  alias: null,
                  name: "reportType",
                  storageKey: null,
                  args: null,
                  concreteType: "RoleType",
                  plural: false,
                  selections: [v2, v8, v7, v3],
                },
                v9,
                v10,
                v11,
                v12,
              ],
            },
            v13,
          ],
        },
      ],
    },
  };
})();
// prettier-ignore
(node/*: any*/).hash = '13a55e9ef03b3f40cb73219f32abdfd2';
module.exports = node;



// WEBPACK FOOTER //
// ./src/subscriptions/__generated__/ReportSubscription.graphql.js